import PinInput from "app/common/components/PinInput";
import useValidation from "app/common/custom-hooks/useValidation";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import SVG from "react-inlinesvg";
import { Link } from "react-router-dom";
import useActionListener from "app/common/custom-hooks/useActionListener";
import { activateAccount, login, requestEmailOTP, resendActivationCode, verifyEmail } from "app/redux/auth/authHandler";
import { Fade } from "@successtar/react-reveal";
import { update } from "app/common/util/Helpers";

const Step2 = ({email, password, setStepsData, isLoading}) => {

    const formRef = useRef();
    const dispatch = useDispatch();
    const [invalidOTP, setInvalidOTP] = useState(false);
    const {validation, data, resetForm} = useValidation(formRef);
    const otp = Object.values(data).join("");

    useEffect(_ => {
        if (validation.allValid && !!otp){
            dispatch(password ? activateAccount({email, otp}) : verifyEmail({email, otp}))
        }
    }, [dispatch, validation.allValid, email, otp, password])

    // Log in with the registration credentials 
    useActionListener("accountActivated,emailOTPVerified,invalidOTP", (action, _, __, errorCode) => {
        if (action === "accountActivated"){
            dispatch(login({email, password}));
        }
        if (action === "emailOTPVerified"){
            update(setStepsData, {step: 3})
        }
        if (action === "invalidOTP" && errorCode === 224){
            resetForm();
            setInvalidOTP(true);
        }
    })
    
    return  <div>
                <form ref={formRef}>
                    <h2
                        className="text-xl md:text-xl font-semibold pb-3 dark:text-white"
                    >
                        Check your email for a code
                    </h2>
                    <p
                        className=" text-grey-7 text-base"
                    >
                        We've sent a 6-digit code to {email?.[0]}*****{email.substr(-8)}, the  code expires in 10 minutes, please enter it soon. 
                    </p>
                    <div className="py-5 sm:py-8">
                        <div>
                            <PinInput checking={isLoading} />
                        </div>
                        <Fade
                            when={isLoading}
                        >
                            <p className="text-grey-6 text-xs py-3">
                                <SVG
                                    src="/assets/media/svg/checking.svg"
                                    className="inline-block fill-current w-4 mr-1"
                                />
                                Checking...
                            </p>
                        </Fade>
                        <Fade
                            when={invalidOTP && !isLoading}
                            bottom
                        >
                            <p className="font-bold text-danger text-xs pb-3">

                                <SVG
                                    src="/assets/media/svg/caution.svg"
                                    className="inline-block fill-current w-5 mr-1"
                                />
                                The code was incorrect please try again or <button className="text-purple-6" onClick={_ => {dispatch(password ? resendActivationCode(email) : requestEmailOTP(email)); setInvalidOTP(false)}}>Resend code</button>
                            </p>
                        </Fade>
                        <Fade
                            when={!isLoading && !invalidOTP}
                        >
                            <div className="flex bg-purple-5 p-4 rounded-xl">
                                <SVG
                                    src="/assets/media/svg/toast/info.svg"
                                    className="inline-block fill-success w-16 mb-auto mr-2 mt-1"
                                />
                                <div className="text-grey-7">
                                    <h6 className=" font-bold pb-0.5">
                                        Why do I need a code
                                    </h6>
                                    <p >
                                        We're a committed to keeping your account secure, the OTP code helps us to do so, learn about our <Link to="/" className="text-primary underline"> Privacy Policy </Link>
                                    </p>
                                </div>
                            </div>
                        </Fade>
                    </div>
                </form>
            </div>
}

export default Step2;